/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Info_E1rm_BodyInputs */

const en_us2_exercise_personal_info_e1rm_body = /** @type {(inputs: Exercise_Personal_Info_E1rm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The heaviest weight you could lift once, with good form. Gyms call it 1RM. You never have to test it: the app works it out from your best set.`)
};

const pt_br2_exercise_personal_info_e1rm_body = /** @type {(inputs: Exercise_Personal_Info_E1rm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É o peso mais alto que você conseguiria levantar uma única vez, com boa técnica. Em academia chamam de 1RM. Você não precisa testar isso: o app calcula pela sua melhor série.`)
};

const es_419_exercise_personal_info_e1rm_body = /** @type {(inputs: Exercise_Personal_Info_E1rm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El peso más alto que podrías levantar una sola vez, con buena técnica. En el gimnasio lo llaman 1RM. No tienes que probarlo: la app lo calcula a partir de tu mejor serie.`)
};

const pt_pt2_exercise_personal_info_e1rm_body = /** @type {(inputs: Exercise_Personal_Info_E1rm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É o peso mais alto que conseguirias levantar uma única vez, com boa técnica. No ginásio chamam-lhe 1RM. Não precisas de o testar: a app calcula-o a partir da tua melhor série.`)
};

const fr_fr2_exercise_personal_info_e1rm_body = /** @type {(inputs: Exercise_Personal_Info_E1rm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La charge la plus lourde que tu pourrais soulever une seule fois, avec une bonne technique. En salle, on l'appelle 1RM. Tu n'as jamais à la tester : l'app la calcule à partir de ta meilleure série.`)
};

const de_de2_exercise_personal_info_e1rm_body = /** @type {(inputs: Exercise_Personal_Info_E1rm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das höchste Gewicht, das du mit sauberer Technik einmal heben könntest. Im Studio heißt das 1RM. Du musst es nie testen: Die App berechnet es aus deinem besten Satz.`)
};

const it_it2_exercise_personal_info_e1rm_body = /** @type {(inputs: Exercise_Personal_Info_E1rm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il peso più alto che potresti sollevare una sola volta, con una buona tecnica. In palestra si chiama 1RM. Non devi mai testarlo: l'app lo calcola dalla tua serie migliore.`)
};

/**
* | output |
* | --- |
* | "The heaviest weight you could lift once, with good form. Gyms call it 1RM. You never have to test it: the app works it out from your best set." |
*
* @param {Exercise_Personal_Info_E1rm_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_info_e1rm_body = /** @type {((inputs?: Exercise_Personal_Info_E1rm_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Info_E1rm_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_info_e1rm_body(inputs)
	if (locale === "es-419") return es_419_exercise_personal_info_e1rm_body(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_info_e1rm_body(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_info_e1rm_body(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_info_e1rm_body(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_info_e1rm_body(inputs)
	return en_us2_exercise_personal_info_e1rm_body(inputs)
});
export { exercise_personal_info_e1rm_body as "exercise-personal.info_e1rm_body" }